export const DEFAULT_PROPERTY_BY_UNIT = {
  m2: ['Área'],
  ml: ['Longitud'],
  m3: ['Volumen'],
  ud: ['Unidad'],
};
